import React, { useEffect, useState } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import { useNavigate } from 'react-router-dom';

import urls from '../../routing/urls';

import styles from './TabsContainer.module.scss';

const ContainerTabs = ({ tab, tabsKey, children, isPublic, queryParams }) => {
  const navigate = useNavigate();

  const [key, setKey] = useState(tab);
  useEffect(() => {
    if (tab && key !== tab) {
      setKey(tab);
    }
  }, [tab]);
  const handleTabChange = (newTab) =>
    navigate(`${isPublic ? '/public' : ''}${urls[tabsKey]}/${newTab}${queryParams ? `?${queryParams}` : ''}`);

  return (
    <div className={tabsKey === 'browse' ? '' : styles.container}>
      <Tabs
        unmountOnExit
        activeKey={key}
        transition={false}
        id={`${tabsKey}-section-tabs`}
        className={styles.tabs}
        onSelect={handleTabChange}
      >
        {children}
      </Tabs>
    </div>
  );
};

export default ContainerTabs;
